import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-equalizer-icon',
    templateUrl: './equalizer-icon.component.html',
    styleUrls: ['./equalizer-icon.component.scss']
})
export class EqualizerIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 24;
        this.width = 24;
    }
}
